/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlatformFee/view.blocks to change it.
import React from 'react'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function PlatformFee({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation/PlatformFeeWarning/Content/AcknowledgementText/Card/PlatformFee",
  text
  
}) {
  return (<React.Fragment
>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text={text}
/>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="By continuing, you acknowledge that the responsible party has authorized this fee."
/>
{children}
</React.Fragment>)
}